import styles from './styles';
import React from "react";
import {Container, withStyles} from "@material-ui/core";
import {ModalDialog} from "../../Modal";
import UploadedFileItem from "./components/UploadedFileItem";
import {LoadingOverlay} from "../../LoadingOverlay";


const UploadedDocuments = (props) => {
    const {
        open, claim, onClose, classes,
        onView, onDownload,
        fetching
    } = props;

    const {claim_number, claim_documents} = claim || {};


    return (<ModalDialog
            open={open}
            noActions
            onClose={onClose}
            title={`Submitted Documents for Claim ${claim_number}`}
            classes={classes}
        >
            {fetching && <LoadingOverlay color="#887fff" />}
            <Container direction="column" className={classes.root}>
                {claim_documents && claim_documents.map((file, index) => {
                    return (<UploadedFileItem
                            file={file}
                            classes={classes}
                            key={index}
                            onDownload={() => {
                                onDownload(file)
                            }}
                            onView={() => {
                                onView(file)
                            }}
                        />)
                })}
            </Container>
        </ModalDialog>)


}

export default withStyles(styles)(UploadedDocuments);